import React from "react";
import { useTranslation } from "react-i18next";
import { DollarSign } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../../../ui/card";
import { Input } from "../../../ui/input";
import { Label } from "../../../ui/label";
import { Switch } from "../../../ui/switch";

const TunisiaCnssCard = ({ formData, handleInputChange }) => {
  const { t } = useTranslation();
  return (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <DollarSign className="h-5 w-5" />
        {t("payrollTN.cnssTitle")}
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="cnss_employee">{t("payrollTN.empContrib")}</Label>
          <Input
            id="cnss_employee"
            type="number"
            step="0.001"
            min="0"
            max="0.2"
            value={formData.cnss_employee_rate}
            onChange={(e) => handleInputChange("cnss_employee_rate", parseFloat(e.target.value))}
          />
          <p className="text-xs text-muted-foreground mt-1">
            {t("payrollTN.empHint")}
          </p>
        </div>

        <div>
          <Label htmlFor="cnss_employer">{t("payrollTN.employerContrib")}</Label>
          <Input
            id="cnss_employer"
            type="number"
            step="0.001"
            min="0"
            max="0.5"
            value={formData.cnss_employer_rate}
            onChange={(e) => handleInputChange("cnss_employer_rate", parseFloat(e.target.value))}
          />
          <p className="text-xs text-muted-foreground mt-1">
            {t("payrollTN.employerHint")}
          </p>
        </div>

        <div>
          <Label htmlFor="cnss_cap">{t("payrollTN.capLabel")}</Label>
          <Input
            id="cnss_cap"
            type="number"
            min="0"
            value={formData.cnss_salary_cap}
            onChange={(e) => handleInputChange("cnss_salary_cap", parseFloat(e.target.value))}
          />
          <p className="text-xs text-muted-foreground mt-1">
            {t("payrollTN.capHint")}
          </p>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <div>
          <Label>{t("payrollTN.autoCalc")}</Label>
          <p className="text-sm text-muted-foreground">
            {t("payrollTN.autoCalcHint")}
          </p>
        </div>
        <Switch
          checked={formData.enable_cnss_calculation}
          onCheckedChange={(checked) => handleInputChange("enable_cnss_calculation", checked)}
        />
      </div>
    </CardContent>
  </Card>
  );
};

export default TunisiaCnssCard;
